/**
 * OosOverlay — grayed overlay for out-of-stock products with oosDisplayOverride.
 *
 * Ported from:
 * - sfcc-website/org_hec/cartridge/models/product/decorators/combinedDisplayOverride.js
 * - SFRA CSS: .isOutOfStock .c-product-tile__image-container::after { background: rgba(204,204,204,0.7) }
 *
 * When `combinedDisplayOverride` is true (product has oosDisplayOverride AND is OOS),
 * this renders a semi-transparent gray overlay on the tile image.
 */

interface OosOverlayProps {
  active: boolean;
}

export function OosOverlay({ active }: OosOverlayProps) {
  if (!active) return null;

  return (
    <div
      className="pointer-events-none absolute inset-0 z-10 bg-[rgba(204,204,204,0.7)]"
      aria-hidden="true"
      data-testid="oos-overlay"
    />
  );
}
